// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --navbar-items: #706565;
    --navbar-items-focus: #201e1e;
    --purple: #673ab7;
    --line-color: #DBD5D5;
    --line-color-light: #F0F0F0;
    --delete-color: #D9534F;

    --black: #000000;
    --low-dark: #303030;
    --grey: #4C4C4C;
    --grey-light: #777777;
    --grey-lighter: #ADADAD;
    --high-dark: #C4C4C4;
    --low-light: #EEEEEE;
    --high-light: #F9F9F9;
    --white-smoke: #FCFCFC;
    --white: #FFFFFF;

    --dark-purple-sensedia: #2B163B;
    --purple-sensedia: #4A2564;
    --primary-purple-sensedia: #5C2E7D;
    --light-purple-sensedia: #8241B0;
    --secondary-purple-sensedia: #8953b0;
    --purple-rain-sensedia: #AC54EB;
    --light-purple2-sensedia: #DAA9FC;
    --lighter-purple-sensedia: #F3DEFE;
    --dark-orange-sensedia: #B53B08;
    --orange-sensedia: #EA5B0C;
    --high-orange-sensedia: #FF7D4A;
    --light-orange-sensedia: #FEBEAA;
    --dark-blue-sensedia: #0066B7;
    --tech-blue-sensedia: #0C77FA;
    --high-blue-sensedia: #0E94FF;
    --light-blue-sensedia: #97D1FF;

    
    --box-shadow-light: rgba(0, 0, 0, 0.192);
    --box-shadow-high: rgba(0, 0, 0, 0.336);
    --btn-box-shadow: 1px 1px 2px rgb(0 0 0 / 30%);

    --background-login: radial-gradient(circle at 1.99% 43.04%,#22282d,transparent 100%),
    radial-gradient(circle at 99.79% 73.72%,#22282d,transparent 58%),
    radial-gradient(circle at 50% 50%,#4f5357,#4f5357 100%)!important;
}

*{
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
}

body, html{
    font-family: 'Roboto', sans-serif;
    background-color: var(--low-light);
    font-size: 62.5%;
}

.disabled{
    opacity: 0.5;
    pointer-events: none;
}

.hidden{
    display: none;
}

.invisible{
    visibility: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/index.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;;IAEvB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;;IAEhB,+BAA+B;IAC/B,0BAA0B;IAC1B,kCAAkC;IAClC,gCAAgC;IAChC,oCAAoC;IACpC,+BAA+B;IAC/B,iCAAiC;IACjC,kCAAkC;IAClC,+BAA+B;IAC/B,0BAA0B;IAC1B,+BAA+B;IAC/B,gCAAgC;IAChC,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;;;IAG9B,wCAAwC;IACxC,uCAAuC;IACvC,8CAA8C;;IAE9C;;qEAEiE;AACrE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[":root{\n    --navbar-items: #706565;\n    --navbar-items-focus: #201e1e;\n    --purple: #673ab7;\n    --line-color: #DBD5D5;\n    --line-color-light: #F0F0F0;\n    --delete-color: #D9534F;\n\n    --black: #000000;\n    --low-dark: #303030;\n    --grey: #4C4C4C;\n    --grey-light: #777777;\n    --grey-lighter: #ADADAD;\n    --high-dark: #C4C4C4;\n    --low-light: #EEEEEE;\n    --high-light: #F9F9F9;\n    --white-smoke: #FCFCFC;\n    --white: #FFFFFF;\n\n    --dark-purple-sensedia: #2B163B;\n    --purple-sensedia: #4A2564;\n    --primary-purple-sensedia: #5C2E7D;\n    --light-purple-sensedia: #8241B0;\n    --secondary-purple-sensedia: #8953b0;\n    --purple-rain-sensedia: #AC54EB;\n    --light-purple2-sensedia: #DAA9FC;\n    --lighter-purple-sensedia: #F3DEFE;\n    --dark-orange-sensedia: #B53B08;\n    --orange-sensedia: #EA5B0C;\n    --high-orange-sensedia: #FF7D4A;\n    --light-orange-sensedia: #FEBEAA;\n    --dark-blue-sensedia: #0066B7;\n    --tech-blue-sensedia: #0C77FA;\n    --high-blue-sensedia: #0E94FF;\n    --light-blue-sensedia: #97D1FF;\n\n    \n    --box-shadow-light: rgba(0, 0, 0, 0.192);\n    --box-shadow-high: rgba(0, 0, 0, 0.336);\n    --btn-box-shadow: 1px 1px 2px rgb(0 0 0 / 30%);\n\n    --background-login: radial-gradient(circle at 1.99% 43.04%,#22282d,transparent 100%),\n    radial-gradient(circle at 99.79% 73.72%,#22282d,transparent 58%),\n    radial-gradient(circle at 50% 50%,#4f5357,#4f5357 100%)!important;\n}\n\n*{\n    margin: 0px;\n    padding: 0px;\n    box-sizing: border-box;\n}\n\nbody, html{\n    font-family: 'Roboto', sans-serif;\n    background-color: var(--low-light);\n    font-size: 62.5%;\n}\n\n.disabled{\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.hidden{\n    display: none;\n}\n\n.invisible{\n    visibility: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
